export default "__VITE_PUBLIC_ASSET__93b83f66__"